/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_RenameInputs */

const cs_settings_venues_rename = /** @type {(inputs: Settings_Venues_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přejmenovat pobočku`)
};

const en_settings_venues_rename = /** @type {(inputs: Settings_Venues_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename office`)
};

/**
* | output |
* | --- |
* | "Rename office" |
*
* @param {Settings_Venues_RenameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_rename = /** @type {((inputs?: Settings_Venues_RenameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_RenameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_rename(inputs)
	return cs_settings_venues_rename(inputs)
});